import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'file-browser',
  templateUrl: './file-browser.component.html',
  styleUrls: ['./file-browser.component.scss'],
})
export class FileBrowserComponent {
  public id: string;
  public files: Array<any>;
  @Input() accept: string;
  @Output() onChange: EventEmitter<any>;

  constructor() {
    this.id = 'fileBrowser_' + new Date().getTime() + '_' + Math.round(Math.random() * 9999);
    this.files = [];
    this.onChange = new EventEmitter<any>();
  }

  fileChange($event: any) {
    this.files = Array.from($event.target.files);
    this.onChange.emit(this.files);
  }
}
